export default "__VITE_ASSET__EPYwsxN5__"